<div class="content wz-table-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">provinces</span></h2>
  </div>

  <p class="wz-lead">Add details to steer the AI for each province. <strong>Everything here is optional</strong>: leave a row blank and the AI decides.</p>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Chaos Level Row -->
    <div class="chaos-level-row mb-4 d-flex align-items-center justify-content-center gap-3">
      <label for="provinceChaosLevel" class="chaos-label fw-bold">Chaos level</label>
      <div class="select-wrapper custom-select-width">
        <ng-select class="wt-select" id="provinceChaosLevel" [(ngModel)]="provinceChaosLevel" [items]="chaosLevels"
          placeholder="Choose…" [clearable]="false" appendTo="body">
          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Table Container -->
    <div class="table-container mx-auto">
      <table class="provinces-table w-100">
        <thead>
          <tr>
            <th class="col-name text-left">Name</th>
            <th class="col-stability text-left">Stability</th>
            <th class="col-prosperity text-left">Prosperity</th>
            <th class="col-notes text-left">Notes</th>
          </tr>
        </thead>
        <tbody>
          @for (province of provincesList; track province; let i = $index) {
            <tr>
              <!-- Name -->
              <td class="col-name">
                <span class="province-name-text">{{ province.name }}</span>
              </td>
              <!-- Stability -->
              <td class="col-stability">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="province.stability" [items]="stabilities"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Prosperity -->
              <td class="col-prosperity">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="province.prosperity" [items]="prosperities"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Notes -->
              <td class="col-notes">
                <input type="text" class="form-input" [(ngModel)]="province.notes"
                  placeholder="Notes for {{ province.name }} (optional)" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

    </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

  </div>
